var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDropIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 21,
    height: 25,
    viewBox: "0 0 32 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "a",
    d: "M 0.1 0 H 25 v 27 H 0.1 z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd",
    transform: "translate(5.5,3.5)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#02b698",
    stroke: "#02b698",
    d: "M 17 14.6 c 0 1 -0.3 1.9 -0.9 2.5 a 0.6 0.6 0 0 0 -0.1 0.8 a 0.5 0.5 0 0 0 0.4 0.2 c 0.1 0 0.2 0 0.3 -0.1 C 17.6 17.1 18 15.9 18 14.6 c 0 -0.3 -0.2 -0.6 -0.5 -0.6 c -0.3 0 -0.5 0.3 -0.5 0.6 z"
  }), /*#__PURE__*/React.createElement("mask", {
    id: "b",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    transform: "matrix(1,0,0,1,0,0)",
    xlinkHref: "#a"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#02b698",
    stroke: "#02b698",
    d: "M 18.2 20.9 c -1.4 1.1 -3.4 1.8 -5.6 1.8 s -4.2 -0.6 -5.6 -1.8 c -1.5 -1.2 -2.3 -2.9 -2.3 -4.9 c 0 -1.7 1.4 -4.6 4.2 -8.3 a 70.6 70.6 0 0 1 3.7 -4.6 a 70.4 70.4 0 0 1 3.7 4.6 c 2.7 3.7 4.2 6.5 4.2 8.3 c 0 2 -0.8 3.7 -2.3 4.9 M 17.4 7 a 70.9 70.9 0 0 0 -4.3 -5.3 a 0.7 0.7 0 0 0 -0.5 -0.2 a 0.7 0.7 0 0 0 -0.5 0.2 c 0 0 -2.2 2.4 -4.3 5.3 c -2.9 3.9 -4.4 7 -4.4 9 c 0 2.4 1 4.4 2.8 5.9 c 1.7 1.4 4 2.1 6.5 2.1 c 2.5 0 4.9 -0.7 6.5 -2.1 c 1.8 -1.5 2.8 -3.5 2.8 -5.9 c 0 -2 -1.5 -5.1 -4.4 -9",
    mask: "url(#b)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDropIcon);
export default __webpack_public_path__ + "static/media/drop-icon.ab003b257e7b1891427114c61e89f733.svg";
export { ForwardRef as ReactComponent };